export class RegistrationClothing{
    registrationId: number;
    size: string;
    quantity: number;
}


// WEBPACK FOOTER //
// ./src/model/registrationClothing.ts